export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00153.69fe1bc7.png";